import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import RouteLayout from '../../RouteLayout'
import Spinner from '../../common/Spinner'
import ApplicantsForm from './Form'
import ApplicantsTable from './Table'
import { applicantDeleteActions } from '../../../redux/reducers/Applicants/applicantsReducer'

const Applicants = () => {
  const dispatch = useDispatch()
  const { list, loader } = useSelector(state => state.reports.applicants)
  const auth = useSelector(state => state.auth.data)

  const handleDelete = xp_key => {
    dispatch(applicantDeleteActions.applicantDeleteRequestStart({ ...auth, xp_key }))
  }

  return (
    <RouteLayout title={'Заявки на поступление'}>
      <ApplicantsForm />
      {loader
        ? <Spinner />
        : <ApplicantsTable data={list} onDelete={handleDelete} />
      }
    </RouteLayout>
  )
}

export default Applicants
